module.exports = __webpack_public_path__ + "img/1.0f7d0c4e.jpg";